export const BONUS_STYLES_TRANSLATIONS_MAP = [
    { type: 'accepted', style: 'active', translation: 'accepted' },
    { type: 'active', style: 'active', translation: 'active' },
    { type: 'wagered', style: 'pending', translation: 'wageringCompleted' },
    { type: 'expired', style: 'pending', translation: 'expired' },
    { type: 'declined', style: 'declined', translation: 'declined' },
    { type: 'cancelled', style: 'declined', translation: 'cancelled' },
    { type: 'redeemed', style: 'active', translation: 'redeemed' },
    { type: 'waiting', style: 'pending', translation: 'waiting' }
];
